import React, { useEffect, useRef, useState } from 'react';

import Basic from 'CommonComponents/slider/Basic';

export default function Slider({ defaultValue = 100, ...props }) {
    const [values, setValues] = useState([defaultValue]);
    const didMountRef = useRef(false);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (props.setFieldValue) {
            props.setFieldValue(props.name, values[0]);
        }
    }, [values]);

    // Keep slider value within bounds if max changes (e.g. another milestone's perc increased).
    // Without this react-range throws when values[0] > max.
    useEffect(() => {
        const max = props.max ?? 100;
        if (values[0] > max) {
            setValues([max]);
        }
        // `values` is intentionally omitted: including it would cause an infinite loop
        // because setValues triggers this effect. We only need to re-run when `props.max` changes.
    }, [props.max]);

    return <Basic values={values} setValues={setValues} {...props}></Basic>;
}
